import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import { quillEditor } from 'vue-quill-editor';
import quillConfig from '@/views/components/editor/quill-config.js';
import { uploadFile } from '@/views/customer/applicationManage/request';
import { cryptoDecrypt } from '@/utils/aes';
export default {
  components: {
    quillEditor
  },
  data() {
    return {
      uploadFile,
      quillOption: quillConfig,
      dialogVisible: false,
      time: '',
      termsForm: {
        name: '',
        linkName: '',
        content: '',
        link: ''
      },
      index: '',
      type: '',
      fileList: [],
      uploadStatus: false,
      showQuill: false
    };
  },
  watch: {
    termsForm: {
      handler() {
        this.time = new Date().getTime();
      },
      deep: true
    }
  },
  computed: {
    TERMRULE() {
      return {
        name: [{
          required: true,
          message: this.$t('请输入') + this.$t('产品名称'),
          trigger: 'blur'
        }, {
          min: 5,
          message: this.$t('至少输入5个字符'),
          trigger: 'blur'
        }, {
          max: 100,
          message: this.$t('最多输入100字符'),
          trigger: 'blur'
        }],
        linkName: [{
          required: true,
          message: this.$t('请上传条款文件'),
          trigger: 'change'
        }],
        content: [{
          required: true,
          message: this.$t('请输入') + this.$t('文本内容'),
          trigger: 'change'
        }]
      };
    },
    TERMRULE2() {
      return {
        name: [{
          required: true,
          message: this.$t('请输入') + this.$t('产品名称'),
          trigger: 'blur'
        }, {
          min: 4,
          message: this.$t('至少输入4个字符'),
          trigger: 'blur'
        }, {
          max: 50,
          message: this.$t('最多输入50字符'),
          trigger: 'blur'
        }],
        linkName: [{
          required: true,
          message: this.$t('请上传条款文件'),
          trigger: 'change'
        }],
        content: [{
          required: true,
          message: this.$t('请输入') + this.$t('文本内容'),
          trigger: 'change'
        }]
      };
    }
  },
  methods: {
    async init(val, index, type) {
      this.showQuill = false;
      this.type = type;
      this.index = index;
      this.termsForm = val;
      this.fileList = [{
        uid: 1,
        status: 'done',
        name: val.linkName,
        url: val.link
      }];
      this.dialogVisible = true;
      setTimeout(() => {
        this.showQuill = true;
      }, 100);
    },
    handleChange({
      file,
      fileList
    }) {
      if (!file.status) {
        return false;
      }
      this.uploadStatus = true;
      fileList = fileList.map(file => {
        if (file.response) {
          file.url = process.env.NODE_ENV === 'production' ? cryptoDecrypt(file.response.data).fileTempUrl : file.response.data.fileTempUrl;
        }
        return file;
      });
      const fileArr = fileList.length != 0 ? [fileList[fileList.length - 1]] : [];
      this.fileList = fileArr;
      if (file.status === 'done') {
        this.$message.success(`${file.name} ` + this.$t('上传成功'));
        this.uploadStatus = false;
      } else if (file.status === 'error') {
        this.$message.error(`${file.name} ` + this.$t('上传失败'));
        this.uploadStatus = false;
      }
      if (fileArr.length != 0 && fileArr[0].url) {
        this.termsForm.linkName = fileArr.length != 0 ? fileArr[0].name : '';
        this.termsForm.link = fileArr.length != 0 ? fileArr[0].url : '';
      }
    },
    beforeUpload(file) {
      console.log(file);
      const isJpgOrPng = file.type === 'application/pdf';
      if (!isJpgOrPng) {
        this.$message.error(this.$t('请上传正确的文件格式,例如:pdf'));
      }
      const num = this.type == 1 ? 10 : 5;
      const isLt5M = file.size / 1024 / 1024 < num;
      if (!isLt5M) {
        this.$message.error(this.$t('文件过大，请选择5M以下文件上传'));
      }
      return isJpgOrPng && isLt5M;
    },
    handleSure() {
      if (this.uploadStatus) {
        return this.$message.error(this.$t('文件上传中,等待上传完成再保存'));
      }
      this.$refs.termsRef.validate(async valid => {
        if (valid) {
          this.$message.success(this.$t('编辑成功') + '!');
          this.$emit('ok', this.termsForm, this.index);
          this.$emit('cancel');
        }
      });
    },
    cancelFun() {
      if (this.uploadStatus) {
        return this.$message.error(this.$t('文件上传中,等待上传完成再保存'));
      }
      this.$emit('cancel');
    }
  }
};